import styled from "styled-components";
import { Button } from "../../atoms/Button";
import { CardTemplate } from "../../templates/CardTemplate";
import { useEmailSendComplete } from "./hook";

export const EmailSendCompletePage: React.FC = () => {
  const { maskedEmail, handleEmailSendComplete } = useEmailSendComplete();

  return (
    <CardTemplate title="メール送信完了">
      <StyledDescriptionContainer>
        <StyledTextContainer>
          下記のメールアドレスに認証番号を送信しました。メール認証へお進みください。
        </StyledTextContainer>

        <StyledEmailContainer>
          <StyledTextContainer>メールアドレス</StyledTextContainer>

          <StyledEmailText>{maskedEmail}</StyledEmailText>
        </StyledEmailContainer>
      </StyledDescriptionContainer>

      <Button
        text="次へ"
        variant="filled"
        onClick={handleEmailSendComplete}
        fullWidth
      />
    </CardTemplate>
  );
};

const StyledDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
`;

const StyledTextContainer = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
`;

const StyledEmailContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 260px;
  height: 30px;
`;

const StyledEmailText = styled.div`
  font-size: 20px;
  font-weight: 400;
  line-height: 150%;
`;

